/* ====================================================================
   FLOOREVER — ÉCHANTILLON DEPUIS LES CARTES (snippets/card-produit.liquid)
   Vanilla JS, chargé en defer. Chargé par les sections qui rendent des
   cartes avec bouton échantillon (floorever-produits,
   floorever-collection, floorever-recherche). Module panier commun
   (assets/floorever-cart.js) utilisé s'il est là, repli sinon.

   Ajout AJAX de la variante échantillon (0 €) directement depuis la
   carte — le clic n'envoie plus vers la fiche (audit accueil,
   chantier B : chaque clic économisé sur une commande à 0 € = un lead
   moins cher). Repli SANS JS : le <form> poste nativement /cart/add.

   RÈGLE MÉTIER : data-max échantillons MAXIMUM PAR PANIER (3), un seul
   par décor — même comptage que la fiche produit et la page
   échantillon : lignes gratuites de /cart.js (final_price == 0),
   RELUES À CHAQUE CLIC (le quota est global : fiche, page échantillon,
   autres cartes).
   - décor déjà au panier -> aucun doublon, bouton « Déjà dans le
     panier » (.is-in-cart, désactivé — le retrait se fait au panier).
     Le décor est reconnu par sa réf. FExxx, quelle que soit la gamme de
     l'échantillon au panier (ticket 3 de la recette) : FECH55308-ECH
     bloque la carte FE308 dont la gamme vedette est 30 Clic Rigid, qui
     pousserait FECR30308-ECH. Réf. de la carte : data-ref, sinon lue
     dans data-sku ; repli sur l'id de variante sans réf. ;
   - plafond atteint -> message calme sous le bouton, pas de rouge ;
   - succès -> « ✓ Ajouté » (.is-added) 3 s, puis état
     « Déjà dans le panier ».

   L'état suit le panier : une seule lecture pour toutes les cartes à
   l'ouverture, au retour sur l'onglet et au retour arrière (bfcache) ;
   sur 'floorever:cart:change', le panier de l'événement suffit. Une
   autre carte du même décor passe en « Déjà dans le panier » ; un
   échantillon retiré au tiroir ou au panier rend le bouton.

   HOOKS : form  [data-carte-ech] (action = route cart/add,
                 data-route-cart SANS .js, data-max, data-ref = réf.
                 décor FExxx, data-sku = SKU de l'échantillon)
           bouton [data-carte-ech-submit]
                 (data-label-success / data-label-incart)
           libellé [data-carte-ech-label]
           statut [data-carte-ech-status] (data-msg-limit / data-msg-error)

   Contrat commun du thème (cf. floorever-product.js) : après ajout,
   pastille panier du header (.cart-link .cart-count) + CustomEvent
   document 'floorever:cart:change' (detail.cart = payload /cart.js).
   ==================================================================== */
(function () {
  'use strict';

  /* Cartes initialisées : { form, routePanier, synchroniser(panier) }. */
  var cartes = [];

  /* Lecture de /cart.js : module commun, sinon fetch direct. */
  function lirePanier(routePanier) {
    if (window.FloorEverCart) return window.FloorEverCart.lire(routePanier);
    return fetch(routePanier, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* Échantillons du panier, lignes gratuites : quantité totale, ids de
     variantes et réf. décor, par le module commun. Repli sans lui, ou
     avec une version qui ne lit pas les réf. : quantité et ids seuls. */
  function gratuits(panier) {
    var FC = window.FloorEverCart;
    if (FC && FC.gratuits) {
      var g = FC.gratuits(panier);
      return { total: g.total, ids: g.ids, refs: g.refs || [] };
    }
    var repli = { total: 0, ids: [], refs: [] };
    ((panier && panier.items) || []).forEach(function (item) {
      if (item.final_price === 0 || item.price === 0) {
        repli.total += item.quantity;
        repli.ids.push(item.variant_id);
      }
    });
    return repli;
  }

  /* Réf. décor d'un SKU d'échantillon, FECR30308-ECH -> FE308, par le
     module commun ; chaîne vide sans lui. */
  function refDuSku(sku) {
    var FC = window.FloorEverCart;
    return FC && FC.refDecor ? FC.refDecor(sku, '') : '';
  }

  /* Met à jour la pastille du header et notifie le reste du thème. */
  function majCompteurPanier(routePanier) {
    /* Module commun (assets/floorever-cart.js) : pastille + événement, source normalisée. */
    if (window.FloorEverCart) return window.FloorEverCart.rafraichir(routePanier, 'carte');
    fetch(routePanier, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        var lien = document.querySelector('.cart-link');
        if (lien) {
          var compteur = lien.querySelector('.cart-count');
          if (!compteur && panier.item_count > 0) {
            compteur = document.createElement('span');
            compteur.className = 'cart-count';
            compteur.setAttribute('aria-hidden', 'true');
            lien.appendChild(compteur);
          }
          if (compteur) compteur.textContent = panier.item_count;
          lien.setAttribute(
            'aria-label',
            'Panier, ' + panier.item_count + ' article' + (panier.item_count > 1 ? 's' : '')
          );
        }
        document.dispatchEvent(
          new CustomEvent('floorever:cart:change', { detail: { cart: panier, source: 'carte' } })
        );
      })
      .catch(function () { /* silencieux : la pastille sera juste obsolète */ });
  }

  function initForm(form) {
    if (form.dataset.carteEchInit === 'true') return;
    form.dataset.carteEchInit = 'true';

    var routeAjout = (form.getAttribute('action') || '/cart/add') + '.js';
    var routePanier = (form.dataset.routeCart || '/cart') + '.js';
    var max = parseInt(form.dataset.max, 10) || 3;

    var champId = form.querySelector('[name="id"]');
    var variantId = champId ? parseInt(champId.value, 10) : 0;
    var ref = (form.dataset.ref || '').toUpperCase() || refDuSku(form.dataset.sku);
    var btn = form.querySelector('[data-carte-ech-submit]');
    var label = form.querySelector('[data-carte-ech-label]');
    var labelBase = label ? label.textContent : '';
    var statut = form.querySelector('[data-carte-ech-status]');
    var enCours = false;
    var ajoute = false;      /* « ✓ Ajouté » à l'écran, 3 s */
    var dedansApres = true;  /* état à rendre à la fin de « ✓ Ajouté » */
    var minuteurStatut = null;
    if (!variantId) return;

    function message(txt) {
      if (!statut) return;
      if (minuteurStatut) { clearTimeout(minuteurStatut); minuteurStatut = null; }
      statut.textContent = txt || '';
      statut.hidden = !txt;
      if (txt) {
        minuteurStatut = window.setTimeout(function () {
          statut.textContent = '';
          statut.hidden = true;
        }, 4000);
      }
    }

    /* Décor déjà au panier : même variante, ou même réf. FExxx venue
       d'une autre gamme. */
    function dejaAuPanier(g) {
      return g.ids.indexOf(variantId) !== -1 || (ref !== '' && g.refs.indexOf(ref) !== -1);
    }

    /* Échantillon du décor au panier : bouton désactivé. */
    function marquerDeja() {
      if (!btn) return;
      btn.disabled = true;
      btn.classList.remove('is-added');
      btn.classList.add('is-in-cart');
      if (label) label.textContent = btn.dataset.labelIncart || 'Déjà dans le panier';
    }

    /* Échantillon retiré du panier, au tiroir, à la page panier ou dans
       un autre onglet : le bouton redevient disponible. */
    function liberer() {
      if (!btn) return;
      btn.disabled = false;
      btn.classList.remove('is-added', 'is-in-cart');
      if (label) label.textContent = labelBase;
    }

    /* Aligne le bouton sur un panier lu ou reçu par événement. Pendant
       « ✓ Ajouté », l'état est retenu pour la fin du retour visuel ;
       pendant un clic, c'est le clic qui décide. */
    function synchroniser(panier) {
      if (!panier || !panier.items) return;
      var dedans = dejaAuPanier(gratuits(panier));
      if (ajoute) { dedansApres = dedans; return; }
      if (enCours) return;
      if (dedans) marquerDeja();
      else liberer();
    }

    cartes.push({ form: form, routePanier: routePanier, synchroniser: synchroniser });

    form.addEventListener('submit', function (e) {
      e.preventDefault(); /* repli sans JS : submit natif vers /cart/add */
      if (enCours || (btn && btn.disabled)) return;
      enCours = true;
      if (btn) btn.setAttribute('aria-busy', 'true');
      message('');

      /* Quota et décor relus à chaque clic : ils ont pu changer ailleurs. */
      lirePanier(routePanier)
        .then(function (panier) {
          var g = gratuits(panier);
          if (dejaAuPanier(g)) {
            marquerDeja();
            var stop = new Error('deja');
            stop.gere = true;
            throw stop;
          }
          if (g.total >= max) {
            message(statut ? statut.dataset.msgLimit : '');
            var stop2 = new Error('limite');
            stop2.gere = true;
            throw stop2;
          }
          return fetch(routeAjout, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('ajout impossible (' + r.status + ')');
          return r.json();
        })
        .then(function () {
          ajoute = true;
          dedansApres = true;
          if (btn) {
            btn.classList.add('is-added');
            if (label) label.textContent = btn.dataset.labelSuccess || label.textContent;
          }
          majCompteurPanier(routePanier);
          window.setTimeout(function () {
            ajoute = false;
            if (dedansApres) marquerDeja();
            else liberer();
          }, 3000);
        })
        .catch(function (err) {
          if (!err || !err.gere) message(statut ? statut.dataset.msgError : '');
        })
        .finally(function () {
          enCours = false;
          if (btn) btn.removeAttribute('aria-busy');
        });
    });
  }

  /* Une lecture du panier pour toutes les cartes de la page. */
  function relireTout() {
    cartes = cartes.filter(function (c) { return document.contains(c.form); });
    if (!cartes.length) return;
    lirePanier(cartes[0].routePanier)
      .then(function (panier) {
        cartes.forEach(function (c) { c.synchroniser(panier); });
      })
      .catch(function () { /* dégradé : le clic relit le panier */ });
  }

  function initTout(scope) {
    (scope || document).querySelectorAll('[data-carte-ech]').forEach(initForm);
  }

  function demarrer() {
    initTout();
    relireTout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  /* Mutation venue d'une autre surface ou d'une autre carte : le panier
     de l'événement suffit, aucune relecture. */
  document.addEventListener('floorever:cart:change', function (e) {
    var panier = e.detail ? e.detail.cart : null;
    cartes.forEach(function (c) { c.synchroniser(panier); });
  });

  /* Retour sur l'onglet, retour arrière (bfcache) : le panier a pu
     changer ailleurs. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') relireTout();
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) relireTout();
  });

  /* Rechargement de section dans l'éditeur de thème. */
  document.addEventListener('shopify:section:load', function (e) {
    initTout(e.target);
    relireTout();
  });
})();
